import React, { useState } from 'react';
import { Form, Input, Tabs } from 'antd';

interface MultiLangInputProps {
  namePrefix: string; // 'working_hours', 'delivery_terms'
  label: string;
  type?: 'input' | 'textarea';
  required?: boolean;
  rows?: number;
  placeholder?: string;
}

export const MultiLangInput: React.FC<MultiLangInputProps> = ({ 
  namePrefix, 
  label, 
  type = 'input',
  required = false,
  rows = 4,
  placeholder
}) => {
  const [activeKey, setActiveKey] = useState('ru');

  const tabs = [
    { key: 'ru', label: 'Русский', flag: '🇷🇺' },
    { key: 'kz', label: 'Қазақша', flag: '🇰🇿' },
    { key: 'en', label: 'English', flag: '🇬🇧' },
  ];

  return (
    <div style={{ marginBottom: 24 }}>
      <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
        {label}
        {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
      </label>
      
      <Tabs 
        activeKey={activeKey} 
        onChange={setActiveKey}
        size="small"
        items={tabs.map(tab => ({
          key: tab.key,
          label: `${tab.flag} ${tab.label}`,
          children: (
            <Form.Item
              name={`${namePrefix}_${tab.key}`}
              rules={tab.key === 'ru' && required ? [
                { required: true, message: `Заполните поле на русском языке` }
              ] : []}
              style={{ marginBottom: 0 }}
            >
              {type === 'textarea' ? (
                <Input.TextArea 
                  rows={rows}
                  placeholder={placeholder || `Введите текст на ${tab.label.toLowerCase()}`}
                />
              ) : (
                <Input 
                  placeholder={placeholder || `Введите текст на ${tab.label.toLowerCase()}`}
                />
              )}
            </Form.Item>
          )
        }))}
      />
    </div>
  );
};